module.exports = __webpack_public_path__ + "img/TEAMModellogo_cn.6145e01a.png";